import { FormikProps, getIn } from 'formik'
import { ReactNode } from 'react'
import { Col, Input, Label, Row } from 'reactstrap'
import Cleave from 'cleave.js/react'
import { OfferSettingsFormValues } from '../types'

interface TogglableInputProps {
    children: ReactNode
    formik: FormikProps<OfferSettingsFormValues>
    name: string
}

const TogglableInput = (props: TogglableInputProps) => {
    const { children, formik, name } = props

    const propertyId = getIn(formik?.values, 'property_id')
    const isChecked = getIn(formik?.values, `${name}_checked`)
    const fieldValue = getIn(formik?.values, name)

    return (
        <Row className="aling-items-center mb-4">
            <Col sm={6} className="align-self-center">
                <div className="form-check">
                    <Input
                        key={`${name}${propertyId}_checkbox`}
                        id={`${name}${propertyId}_checkbox`}
                        name={`${name}_checked`}
                        type="checkbox"
                        className="form-check-input"
                        onChange={(e) => {
                            formik?.setFieldValue(`${name}_checked`, e.target.checked)
                        }}
                        checked={isChecked}
                    />
                    <Label className="form-check-label" for={`${name}${propertyId}_checkbox`}>
                        {children}
                    </Label>
                </div>
            </Col>
            <Col sm={6}>
                <Cleave
                    options={{
                        numeral: true,
                        numeralDecimalMark: ',',
                        delimiter: '.',
                    }}
                    value={isChecked && fieldValue}
                    onBlur={(e) => {
                        formik?.setFieldValue(name, e.target.value)
                    }}
                    disabled={!isChecked}
                    id={`${name}${propertyId}`}
                    name={name}
                    className="form-control"
                />
            </Col>
        </Row>
    )
}

export default TogglableInput
